import { useMutation } from "@tanstack/react-query";
import { rateDuvidaFrequente } from "../../../api";

const useRateDuvidaFrequente = () => {
    return useMutation({
        mutationFn: ({ id, util }: { id: number; util: boolean }) =>
            rateDuvidaFrequente(id, util),
    });
};

export default useRateDuvidaFrequente;